import { Query } from 'cogent-js';
import BaseApiService from './base';

export default class QuestionsApiService extends BaseApiService {
  constructor() {
    super();
    this.query = new Query();
  }

  get(id) {
    return this.request({
      method: 'get',
      url: `/survey_questions/${id}`
    });
  }
}
